import './styles/styles.scss';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { ToastProvider } from 'react-toast-notifications';

import Snackbar from 'components/Snackbar';
import history from 'utils/history';

import App from './App';
import { store } from './redux/store';

ReactDOM.render(
  <Provider store={store}>
    <Router history={history}>
      <ToastProvider
        autoDismiss
        autoDismissTimeout={5000}
        components={{ Toast: Snackbar }}
        placement='bottom-center'
      >
        <App />
      </ToastProvider>
    </Router>
  </Provider>,
  document.getElementById('root')
);

// hot module reloading
if ((module as any).hot) {
  (module as any).hot.accept();
}
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
